import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { getTrackByFn } from '@y42/angular/util';
import { DateTimeFormat } from '@y42/date-time';
import { GitBranch } from '../../worker';

@UntilDestroy()
@Component({
  selector: 'y42-git-branch-list',
  templateUrl: './git-branch-list.component.html',
  styleUrls: ['./git-branch-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GitBranchListComponent<T extends GitBranch = GitBranch> {
  @Input() branches: T[] = [];

  @Input() activeBranch: T | null = null;

  @Input() selectedBranch: T | null = null;

  @Output() branchClicked = new EventEmitter<T>();

  @ContentChild(TemplateRef) itemTemplate!: TemplateRef<{ $implicit: T }>;

  protected readonly timeAgoFormat = DateTimeFormat.MediumDate;

  itemContext!: { $implicit: T };

  readonly trackByName = getTrackByFn<T>('name');
}
